import ErrorMessage from '@shared/components/ErrorMessage/ErrorMessage';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Notification } from 'assets/icons/Notification.svg';

import useCreateNewRoomDataContext from '../../CreateNewRoomDataProvider/useCreateNewRoomDataContext';

const RemindersReview = () => {
  const { t } = useTranslation();
  const {
    roomForm: {
      // getValues,
      formState: { errors },
    },
  } = useCreateNewRoomDataContext();

  // const reminders = getValues('reminders');
  const reminderError = errors.reminders?.find?.((err) => err?.amount?.message);
  const reminderErrorMessage = reminderError?.amount?.message;

  return (
    <div className="flex gap-5">
      <Notification className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5 mt-1" />
      <div className="flex flex-col w-full">
        <div className="w-full flex justify-between items-center gap-1">
          <span className="text-black text-size-sm">
            {t('reminders_review_description')}
            {/* {getRemindersReview(reminders)} */}
          </span>
          {/* <EditButton step={CreateNewRoomStepsEnum.SET_AUTO_REMINDERS} /> */}
        </div>
        <ErrorMessage message={reminderErrorMessage} className="mt-2" />
      </div>
    </div>
  );
};

export default RemindersReview;
